// extracted by mini-css-extract-plugin
export var closeBtn = "cookie-consent-module--closeBtn--V+PuM";
export var consentContainer = "cookie-consent-module--consentContainer--2qqvu";
export var header = "cookie-consent-module--header--D6Jtf";